const NXCartCheck = ({ className }: { className?: string }) => {
  return (
    <svg
      width="23"
      height="24"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
    >
      <g clipPath="url(#clip0_4287_2916)">
        <path
          d="M10.9459 13.5C10.6698 13.5 10.4459 13.2761 10.4459 13C10.4459 12.7239 10.6698 12.5 10.9459 12.5C11.2221 12.5 11.4459 12.7239 11.4459 13C11.4459 13.2761 11.2221 13.5 10.9459 13.5Z"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.44592 13.5C4.16978 13.5 3.94592 13.2761 3.94592 13C3.94592 12.7239 4.16978 12.5 4.44592 12.5C4.72207 12.5 4.94592 12.7239 4.94592 13C4.94592 13.2761 4.72207 13.5 4.44592 13.5Z"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.5 0.5H3L3.26316 3M3.26316 3L3.90576 9.10468C3.95933 9.61363 4.3885 10 4.90026 10H11.2192C11.6781 10 12.0781 9.6877 12.1894 9.24254L13.4394 4.24254C13.5972 3.61139 13.1198 3 12.4692 3H3.26316Z"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.42004 6.75L7.75338 7.75L9.94088 5.25"

          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4287_2916">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NXCartCheck;
